import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=abecd1e4&scoped=true&"
import script from "./TaskTable.vue?vue&type=script&lang=js&"
export * from "./TaskTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskTable.vue?vue&type=style&index=0&id=abecd1e4&prod&scoped=true&lang=scss&"
import style1 from "./TaskTable.vue?vue&type=style&index=1&id=abecd1e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abecd1e4",
  null
  
)

export default component.exports